import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import api from '../api'

Vue.use(Vuex)

const state = {
  auth: {
    authorized: false,
    user: {}
  },
  isLoading: false,
  errorMessage: '',
  cart: [],
  breadcrumbs: []
}

const getters = {
  user: state => state.auth.user,
  authorized: state => state.auth.authorized,
  isLoading: state => state.isLoading,
  errorMessage: state => state.errorMessage,
  cart: state => state.cart,
  cartCount: state => state.cart.length,
  breadcrumbs: state => state.breadcrumbs
}

const actions = {
  login: ({ commit, dispatch }, user) => {
    return api.Account
      .Login(user.account, user.password)
      .then((response) => {
        commit('login', response.data)
        dispatch('getProfile')
      })
  },

  getProfile: ({ commit }) => {
    return api.Account
      .Profile()
      .then((response) => {
        commit('updateProfile', response)
      })
  },

  updateProfile: ({ commit }, payload) => {
    return api.Account
      .updateProfile(payload)
      .then((response) => {
        commit('updateProfile', response)
      })
  },

  logout: ({ commit }) => {
    commit('logout')
    // api.Account.LogOut()
  },

  addToCart: ({ commit }, payload) => {
    commit('addToCart', payload)
  }
}

const mutations = {
  login (state, data) {
    window.localStorage.setItem('token', data.access_token)
    state.auth.userRole = data.rolename
    state.auth.authorized = true
  },

  logout (state) {
    window.localStorage.removeItem('token')
    state.auth.authorized = false
    state.auth.user = {}
  },

  isLoading (state, value) {
    state.isLoading = value
  },

  setErrorMessage (state, message) {
    state.errorMessage = message
  },

  updateProfile (state, payload) {
    state.auth.user = payload.data
  },

  addToCart (state, payload) {
    state.cart = []
    payload.quantity = 1
    state.cart.push({
      name: payload.name,
      quantity: payload.quantity,
      cost: payload.cost,
      id: payload.id,
      isDigital: payload.isDigital || false
    })
  },

  initBreadcrumb (state) {
    state.breadcrumbs = []
    state.breadcrumbs.push({
      text: '首頁',
      link: '/'
    })
    state.errorMessage = ''
  },

  addBreadcrumb (state, payload) {
    var idx = state.breadcrumbs.map(function (e) { return e.text }).indexOf(payload.text)
    idx > -1 ? state.breadcrumbs.splice(idx + 1, state.breadcrumbs.length - idx) : state.breadcrumbs.push(payload)
  }
}

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {},
  strict: debug,
  plugins: [createPersistedState({
    paths: [
      'auth'
    ]
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js